import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoDirectivesModule } from '../directives/avano-directives.module';
import { AvanoPanelComponent } from './avano-panel.component';

@NgModule({
  imports: [CommonModule, AvanoDirectivesModule],
  declarations: [AvanoPanelComponent],
  exports: [AvanoPanelComponent, AvanoDirectivesModule]
})
export class AvanoPanelModule { }
